module.exports = __webpack_public_path__ + "media/images/cancel-expand-2138b6c5c0249f3d9ae6fea3d5e2ead01654b6e9f965023180c0a37d5db4a3cc.svg";